module.exports = __webpack_public_path__ + "static/perfiles-f12238f1434e66b4ca64f3fba8bc07bd.png";